/**
 * Global Imports
*/

import { ChatUserstate } from 'tmi.js';

/**
 * Local Imports
*/

import { TwitchWriteMessage } from '@system/Twitch';
import { isUser, User, UserCreate } from '@system/User';

/**
 * Relative Imports
*/

import { CommandHandler, CommandEventHandler } from './types';

/**
 * Locals
*/

let events: Array<CommandEventHandler> = [];
let commands: Record<string, CommandHandler> = {};

/**
 * Public Functions
*/

/**
 * @return {void}
 */
export function CommandRegister(
  name: string,
  handler: CommandHandler): void
{
  commands[name] = handler;
}

/**
 * @return {void}
 */
export function CommandDispatch(
  channel: string,
  user: User | ChatUserstate,
  name: string,
  contents?: string): void
{
  const lower = name.toLowerCase();
  const payload = {
    name,
    contents,
    user: isUser(user) ? user : UserCreate(user),
  };

  let i = events.length;

  while (i--) {
    events[i](payload);
  }

  if (lower in commands) {
    commands[lower](channel, user, contents);
  } else {
    //TwitchWriteMessage(channel, `Unknown command !${ name }`);
  }
}

/**
 * @param {ChatUserstate} state
 * @param {CommandEventHandler} handler
 *
 * @return {ChatMessage}
 */
 export function CommandAddEventHandler(
  channel: string,
  handler: CommandEventHandler): void
{
  events.push(handler);
}
